import React from "react";

type QuestionChipInputProps = {
  questionList: string[];
  draft: string;
  inputRef: React.MutableRefObject<HTMLTextAreaElement | null>;
  onFocusInput: () => void;
  onChangeDraft: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onPaste: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
};

/**
 * 質問をチップ形式で表示しながら入力する
 * @return 画面要素
 */
const QuestionChipInput: React.FC<QuestionChipInputProps> = ({
  questionList,
  draft,
  inputRef,
  onFocusInput,
  onChangeDraft,
  onKeyDown,
  onPaste,
}) => {
  return (
    <div className="dify-chat-main-space">
      <div className="dify-input-textbox" onClick={onFocusInput}>
        {questionList.map((question, index) => (
          <div key={`${question}-${index}`} className="dify-input-chip">
            {question}
          </div>
        ))}
      </div>
      <div className="dify-input-area">
        <textarea
          ref={(el) => {
            inputRef.current = el;
          }}
          className="dify-input-inline"
          value={draft}
          onChange={(event) => onChangeDraft(event.target.value)}
          onKeyDown={onKeyDown}
          onPaste={onPaste}
          placeholder={draft.length === 0 ? "Enterで質問を決定。Shift + Enterで改行。" : ""}
          aria-label="質問内容を入力してください"
        />
      </div>
    </div>
  );
};

export default QuestionChipInput;
